import Button from '@/components/ui/button';
import Card from '@/components/ui/cards/card';
import Link from '@/components/ui/link';
import Logo from '@/components/ui/logo';
import { Routes } from '@/config/routes';
import {
  useLogout,
  useResendVerificationEmail,
  useUser,
} from '@/framework/user';
import DashboardLayout from '@/layouts/_dashboard';
import { useToken } from '@/lib/hooks/use-token';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export { getStaticProps } from '@/framework/general.ssr';

const VerifyEmail = () => {
  const [isClient, setIsClient] = useState(false);
  const { getEmailVerified } = useToken();
  const router = useRouter();
  const { t } = useTranslation('common');
  const { emailVerified } = getEmailVerified();
  const { mutate: logout, isLoading: isLogoutLoader } = useLogout();
  const { mutate: sendVerifyEmail, isLoading: isVerifying } =
    useResendVerificationEmail();

  useUser();

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (emailVerified) {
    router.push('/profile');
  }

  let redirect_to = '';
  if (typeof window !== 'undefined') {
    redirect_to = window.location.href;
    if (redirect_to.endsWith(Routes.verifyEmail)) {
      redirect_to = redirect_to.substring(
        0,
        redirect_to.length - Routes.verifyEmail.length,
      );
    }
  } else {
    const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || 'localhost:5000';
    const cleanPath = router.asPath.replace(Routes.verifyEmail, '');
    redirect_to = `${baseUrl}${cleanPath}`.replace(/\/$/, '');
  }

  const handleLogout = () => {
    logout();
    router.push(Routes.home);
  };

  return isClient ? (
    <section
      className="relative flex min-h-screen w-full items-center justify-center bg-[#F4F6F7] px-4 py-5 md:py-8"
      suppressHydrationWarning
    >
      <div className="max-w-[36rem]">
        <Card className="text-center !shadow-900 md:px-[4.375rem] md:py-[2.875rem]">
          <Logo />

          <h2 className="mb-5 mt-2 text-2xl font-semibold">
            {t('common:email-not-verified')}
          </h2>

          <p className="mb-16 text-lg text-[#969FAF]">
            {t('email-not-description')}
          </p>

          <div className="space-y-3">
            <Button
              onClick={() => sendVerifyEmail({ redirect_to })}
              disabled={isVerifying || !!isLogoutLoader}
              loading={isVerifying}
              className="!h-13 w-full hover:bg-accent-hover"
            >
              {t('resend-verification-button-text')}
            </Button>
            <Button
              type="button"
              variant="outline"
              className="!h-13 w-full"
              onClick={() => handleLogout()}
              disabled={!!isVerifying || isLogoutLoader}
              loading={isLogoutLoader}
            >
              {t('auth-menu-logout')}
            </Button>
          </div>
          <div className="mt-4">
            <Link
              href={Routes.home}
              className="inline-flex items-center text-bolder underline hover:text-body-dark hover:no-underline focus:outline-none sm:text-base"
            >
              {t('404-back-home')}
            </Link>
          </div>
        </Card>
      </div>
    </section>
  ) : null;
};

// VerifyEmail.authenticationRequired = true;

VerifyEmail.getLayout = function getLayout(page: React.ReactElement<any>) {
  return <DashboardLayout>{page}</DashboardLayout>;
};

export default VerifyEmail;
